import moment from 'moment';

let Format = {
	format: (date, format) => {
		return moment(date).format(format || 'YYYY-MM-DD HH:mm:ss')
	}
}

export default Format;


// WEBPACK FOOTER //
// ./src/assets/js/utils.date.js